const STORAGE_KEY = "resultsContact";

export interface ResultsContact {
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone: string | null;
}

const EMPTY_CONTACT: ResultsContact = {
  email: null,
  first_name: null,
  last_name: null,
  phone: null,
};

function asNullableString(value: unknown): string | null {
  return value === undefined || value === null || value === "" ? null : String(value);
}

/**
 * Patient contact details for the booking prefill travel through sessionStorage
 * rather than the redirect URL, so they never land in URLs, history, or logs.
 * They only reach the results page when it is served from this same origin.
 */
export function saveResultsContact(assessment: Record<string, unknown>): void {
  const contact: ResultsContact = {
    email: asNullableString(assessment.email),
    first_name: asNullableString(assessment.first_name),
    last_name: asNullableString(assessment.last_name),
    phone: asNullableString(assessment.phone),
  };
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(contact));
  } catch {
    // Storage can be unavailable (e.g. blocked third-party storage); the
    // booking form then simply opens without a prefill.
  }
}

export function loadResultsContact(): ResultsContact {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return EMPTY_CONTACT;
    const parsed = JSON.parse(stored) as Record<string, unknown>;
    return {
      email: asNullableString(parsed.email),
      first_name: asNullableString(parsed.first_name),
      last_name: asNullableString(parsed.last_name),
      phone: asNullableString(parsed.phone),
    };
  } catch {
    return EMPTY_CONTACT;
  }
}
